export default __webpack_public_path__ + "static/media/topbar-icon-sign-out.0a783ab7.svg";